let ready = function () {
    let pathname = window.location.pathname;
    $(`.nav > li > a[href="${pathname}"]`).addClass('active');
};

$(document).on('turbo:load', ready);